/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import LoginBg from '../../../_supplier/assets/media/login bg.png'

export const authCardClassName =
  'w-full max-w-[496px] h-fit min-h-0 lg:min-h-[595px] rounded-[20px] bg-gradient-to-b from-[#C2DBF9] to-white shadow-[0_0_20px_0_rgba(0,0,0,0.10)] p-6 sm:p-10 pr-[86px] lg:pl-[784px] lg:pr-[86px] lg:pt-[86px]'
const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid min-vh-100 h-100'>
      <div
        className='d-flex flex-column flex-lg-row-fluid w-lg-50 bg-body px-4 py-6 sm:px-6 sm:py-8 lg:p-25 order-2 overflow-auto min-h-0'
        style={{
          backgroundImage: `url(${LoginBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className='d-flex w-100 justify-content-center justify-content-lg-end align-items-center flex-lg-row-fluid py-2 sm:py-4 lg:py-0' style={{paddingRight: '86px'}}>
          <Outlet />
        </div>
      </div>
    </div>
  )
}
export {AuthLayout}
